// @flow
import theme from 'styled-theming'
import myTheme from './theme'
import { rgb } from '../helpers'

const { color } = myTheme

export const themedTextColor = theme('mode', {
  dark: color.cyan,
  light: color.purple,
})

export const themedTextColorRgb = theme('mode', {
  dark: rgb(color.cyan),
  light: rgb(color.purple),
})



// WEBPACK FOOTER //
// ./src/styles/themed-text-color.js